<template>
  <group-list :data='data'/>
</template>

<script>
  import groupList from './groupList'

  export default {
    components: {
      groupList
    },
    props: {
      data: Array
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/elite/parner.vue